import type { PizzaEvaluationMetadata } from "@/api/custom-schema";
import { StatusBadge } from "@/components/status-badge";
import { useLocalization } from "@/context/localization-context";
import { pizzaVerdict } from "@/lib/pizza-verdict";

/** OK / NOK and, for a NOK, what failed. */
export const VerdictCell = ({ metadata }: { metadata?: PizzaEvaluationMetadata | null }) => {
  const { t } = useLocalization();
  const verdict = pizzaVerdict(metadata);
  if (verdict.kind === "not_evaluated") {
    return <StatusBadge status={null} label={t("status.notEvaluated")} tone="neutral" size="xs" />;
  }
  const label =
    verdict.kind === "no_pizza"
      ? t("status.noPizza")
      : verdict.kind === "invalid_photo"
        ? t("status.invalidShort")
        : verdict.status === "OK"
          ? t("status.ok")
          : verdict.status === "NOK"
            ? t("status.nok")
            : t("status.na");
  return (
    <div className="flex min-w-0 max-w-56 flex-col items-start gap-0.5">
      <StatusBadge status={verdict.status} label={label} tone={verdict.kind === "ok" ? "ok" : "nok"} />
      {verdict.kind !== "ok" && verdict.reasons.length > 0 && (
        <span className="w-full truncate text-xs text-red-300/80" title={verdict.reasons.join(", ")}>
          {verdict.reasons.join(", ")}
        </span>
      )}
    </div>
  );
};

